import {ConfigObjectType} from '@wallaby-ui/core';
import {EnsureLoggedInContainerLayoutContainer} from '@wallaby-ui/layout';
import * as React from 'react';

import LoggedInLayout from './LoggedInLayout';

interface OwnProps {
  config: ConfigObjectType;
}

type Props = OwnProps;

const EnsureLoggedInLayout: React.FC<Props> = ({config}) => (
  <EnsureLoggedInContainerLayoutContainer config={config}>
    <LoggedInLayout config={config} />
  </EnsureLoggedInContainerLayoutContainer>
);

EnsureLoggedInLayout.displayName = 'EnsureLoggedInLayout';

export default EnsureLoggedInLayout;
